const saveToSessionStorage = (key, data) => {
  const { sessionStorage } = window;
  sessionStorage.setItem(key, JSON.stringify(data));
  return true;
};

const deleteFromSessionStorage = (key) => {
  const { sessionStorage } = window;
  sessionStorage.removeItem(key);
  return true;
};

const retreiveFromSessionStorage = (key) => {
  const { sessionStorage } = window;
  try {
    return JSON.parse(sessionStorage.getItem(key));
  } catch (error) {
    console.error(error);
    return null;
  }
};

export {
  deleteFromSessionStorage,
  retreiveFromSessionStorage,
  saveToSessionStorage,
};
